export default "__VITE_ASSET__CG7k4Vrv__"